"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataGetter = void 0;
var lodash_1 = __importDefault(require("lodash"));
var AppConfig_1 = require("./AppConfig");
var DataContainer_1 = require("./DataContainer");
var isNumeric_1 = require("./format/isNumeric");
var DataGetter = (function () {
    function DataGetter() {
        var _this = this;
        this.WorkerTimer = require('worker-timer');
        this._workerStatus = false;
        this.jqXHRList = [];
        this.initialCallBack = null;
        this.onDataUpdateCallBack = null;
        this.isInitialize = true;
        this.localStargeKey = 'mierukaWebMesuringData';
        this.STATUS_OK = 'succeed';
        this.startWorker = function () {
            var interval = AppConfig_1.AppConfig.APP_CONFIG.getDataInterval;
            _this.worker = _this.WorkerTimer.setInterval(function () {
                _this.getDataInParallelsInAjax();
            }, interval);
        };
        this.stopWorker = function () {
            _this.WorkerTimer.clearTimeout(_this.worker);
        };
        this.getDataInParallelsInAjax = function () {
            _this.jqXHRList = [];
            var app = _this;
            var numDataset = DataContainer_1.DataContainer.config.dataset.length;
            var countLoadedData = 0;
            var hasLoadError = false;
            lodash_1.default.forEach(DataContainer_1.DataContainer.config.dataset, function (datasetConfig) {
                var $ajax = $.ajax({
                    url: datasetConfig.dataUrl,
                    type: 'GET',
                    headers: {
                        'x-api-key': AppConfig_1.AppConfig.APP_CONFIG.APIKey,
                        'Content-Type': 'application/json',
                    },
                })
                    .done(function (data) {
                    if (data.apiResponse.apiStatus === _this.STATUS_OK) {
                        DataContainer_1.DataContainer.setDataSetById(datasetConfig.id, data.apiResponse.apiResult);
                        app._workerStatus = true;
                    }
                    allWait(true);
                })
                    .fail(function (data) {
                    DataContainer_1.DataContainer.setDataSetById(datasetConfig.id, {});
                    allWait(false);
                });
                _this.jqXHRList.push($ajax);
            });
            $.when.apply(null, _this.jqXHRList);
            function allWait(isLoadSuccess) {
                countLoadedData += 1;
                hasLoadError = hasLoadError || !isLoadSuccess;
                if (countLoadedData >= numDataset) {
                    app.calculate();
                    if (!hasLoadError) {
                        app.saveToLocalStrage(app.localStargeKey, DataContainer_1.DataContainer.measuringData);
                    }
                    app.onDataUpdate();
                }
            }
        };
        this.onDataUpdate = function () {
            if (_this.initialCallBack && _this.isInitialize) {
                _this.initialCallBack.method(_this.initialCallBack.arg);
                _this.isInitialize = false;
            }
            if (_this.onDataUpdateCallBack) {
                _this.onDataUpdateCallBack();
            }
        };
        this.isSkeletonValue = function (value) {
            return typeof value !== 'undefined';
        };
        this.isGraphData = function (data) {
            return typeof data !== 'undefined' && typeof data['@gid'] !== 'undefined';
        };
        this.collectSkeletonValues = function (targets) {
            var values = [];
            var value;
            lodash_1.default.forEach(targets, function (target) {
                var level = target.level, type = target.type;
                var path = (0, isNumeric_1.isNumeric)(target.nodeId)
                    ? ['skeleton', 'node', target.nodeId, level, type]
                    : ['skeleton', level, type];
                value = lodash_1.default.get(DataContainer_1.DataContainer.getDataSetById(target.targetId), path);
                if (_this.isSkeletonValue(value)) {
                    values.push(value);
                }
                else {
                    values.length = 0;
                    return false;
                }
            });
            return values;
        };
        this.collectGraphDatum = function (targets) {
            var datum = [];
            var data;
            lodash_1.default.forEach(targets, function (target) {
                data = lodash_1.default.get(DataContainer_1.DataContainer.getDataSetById(target.targetId), [
                    'chart',
                    'graphs',
                    'graph',
                    target.dataId,
                ]);
                if (_this.isGraphData(data)) {
                    datum.push(data);
                }
                else {
                    datum.length = 0;
                    return false;
                }
            });
            return datum;
        };
        this.isCalcItemSkeleton = function (value) {
            return value.item === 'skeleton';
        };
        this.calculate = function () {
            lodash_1.default.forEach(DataContainer_1.DataContainer.config.calculation, function (calc) {
                var _a, _b, _c;
                if (_this.isCalcItemSkeleton(calc)) {
                    var target = calc.target, method = calc.method, id = calc.id, outputLevel = calc.outputLevel, outputType = calc.outputType, nodeId = calc.nodeId;
                    var values = _this.collectSkeletonValues(target);
                    if (!values.length) {
                        DataContainer_1.DataContainer.setDataSetById(id, {});
                        return false;
                    }
                    var result = String(_this.calcSkeleton(values, method));
                    var skeleton = (_a = {},
                        _a[outputLevel] = (_b = {},
                            _b[outputType] = result,
                            _b),
                        _a);
                    var calced = (0, isNumeric_1.isNumeric)(nodeId)
                        ? {
                            skeleton: (_c = {},
                                _c[nodeId] = skeleton,
                                _c),
                        }
                        : {
                            skeleton: skeleton,
                        };
                    DataContainer_1.DataContainer.setDataSetById(id, calced);
                }
                else {
                    var target = calc.target, method = calc.method, id = calc.id;
                    var datum = _this.collectGraphDatum(target);
                    if (!datum.length) {
                        DataContainer_1.DataContainer.setDataSetById(id, {});
                        return false;
                    }
                    var graphData = DataContainer_1.DataContainer.getDataSetById(target[target.length - 1].targetId);
                    if (!DataContainer_1.DataContainer.isGraphApiResult(graphData))
                        return false;
                    var calced = {
                        chart: {
                            series: graphData.chart.series,
                            graphs: {
                                graph: [_this.calcChart(datum, method)],
                            },
                        },
                    };
                    DataContainer_1.DataContainer.setDataSetById(id, calced);
                }
            });
        };
        this.calcSkeleton = function (values, method) {
            if (!values.some(isNumeric_1.isNumeric))
                return;
            var initialValue = 0;
            var result = lodash_1.default.reduce(values, function (sum, n) {
                if ((0, isNumeric_1.isNumeric)(sum) && (0, isNumeric_1.isNumeric)(n)) {
                    return Number(sum) + Number(n);
                }
                if ((0, isNumeric_1.isNumeric)(sum)) {
                    return Number(sum);
                }
                if ((0, isNumeric_1.isNumeric)(n)) {
                    return Number(n);
                }
                return Number.NaN;
            }, initialValue);
            if (method === 'sum')
                return result;
            var validDivide = 0;
            lodash_1.default.forEach(values, function (value) {
                if ((0, isNumeric_1.isNumeric)(value)) {
                    validDivide += 1;
                }
            });
            return result / validDivide;
        };
        this.calcChart = function (datas, method) {
            var result = [];
            var accumulator = datas[0].value;
            result = lodash_1.default.reduce(datas, function (a, b) {
                var temporaryData = [];
                lodash_1.default.forEach(a, function (value, index) {
                    var sumResult = '';
                    var aValue = value['#text'];
                    var bValue = b.value[index]['#text'];
                    if ((0, isNumeric_1.isNumeric)(aValue) && (0, isNumeric_1.isNumeric)(bValue)) {
                        sumResult = String(Number(aValue) + Number(bValue));
                    }
                    else if ((0, isNumeric_1.isNumeric)(aValue)) {
                        sumResult = aValue;
                    }
                    else if ((0, isNumeric_1.isNumeric)(bValue)) {
                        sumResult = bValue;
                    }
                    var newValue = {
                        '@xid': String(value['@xid']),
                    };
                    if ((0, isNumeric_1.isNumeric)(sumResult)) {
                        newValue['#text'] = sumResult;
                    }
                    temporaryData.push(newValue);
                });
                return temporaryData;
            }, accumulator);
            if ('average' === method) {
                lodash_1.default.forEach(result, function (resultData, index) {
                    var validDivide = 0;
                    if ((0, isNumeric_1.isNumeric)(resultData['#text'])) {
                        lodash_1.default.forEach(datas, function (data) {
                            if ((0, isNumeric_1.isNumeric)(data.value[index]['#text'])) {
                                validDivide += 1;
                            }
                        });
                        resultData['#text'] = String(Number(resultData['#text']) / validDivide);
                    }
                });
            }
            return {
                '@gid': '1',
                value: result,
            };
        };
        this.saveToLocalStrage = function (key, data) {
            data.saveTime = new Date().getTime();
            try {
                localStorage.setItem(key, JSON.stringify(data));
            }
            catch (error) {
            }
        };
        this.getFromLocalStrage = function () {
            try {
                var obj = localStorage.getItem(_this.localStargeKey);
                return obj ? JSON.parse(obj) : null;
            }
            catch (error) {
                return null;
            }
        };
        this.hasCurrentData = function () {
            var targetData = _this.getFromLocalStrage();
            if (targetData) {
                var dataTime = new Date(targetData.saveTime);
                var now = new Date();
                var diff = now.getTime() - dataTime.getTime();
                if (diff <= AppConfig_1.AppConfig.APP_CONFIG.getDataInterval) {
                    return true;
                }
                return false;
            }
            return false;
        };
    }
    Object.defineProperty(DataGetter.prototype, "workerStatus", {
        get: function () {
            return this._workerStatus;
        },
        enumerable: false,
        configurable: true
    });
    DataGetter.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                this.localStargeKey = "".concat(this.localStargeKey, "-").concat(AppConfig_1.AppConfig.APP_CONFIG.mierukaWebId);
                if (this.hasCurrentData()) {
                    data = this.getFromLocalStrage();
                    if (data) {
                        DataContainer_1.DataContainer.measuringData = data;
                        this.onDataUpdate();
                    }
                    else {
                        this.getDataInParallelsInAjax();
                    }
                }
                else {
                    this.getDataInParallelsInAjax();
                }
                this.startWorker();
                return [2, true];
            });
        });
    };
    return DataGetter;
}());
exports.DataGetter = DataGetter;
